export default __webpack_public_path__ + "static/media/baton_team_4.f228ef6b.jpg";